import { useRef, useState } from 'react'

const useClinicChange = (clinicId: string, reset: () => void): void => {
  const resetRef = useRef(reset)
  resetRef.current = reset
  const [trackedClinicId, setTrackedClinicId] = useState(clinicId)

  if (trackedClinicId !== clinicId) {
    setTrackedClinicId(clinicId)
    resetRef.current()
  }
}

export default useClinicChange
